<template>
  <div class="printControlTapeWrapper" v-if="company && businessUnit && asyncDataStatus_ready">
    <v-btn
      color="white"
      text
      @click="closeWindow"
      style="background: red;right: 1rem;top: 1rem;position: fixed;"
    >
      Prekliči
    </v-btn>
    <div style="display: flex;" v-if="!deviceId">
      <PrintControlTape
        v-for="device in devices"
        :key="device.id"
        ref="printControlTape"
        :invoices="invoicesDevice(device.id)"
        :invoiceHeader="returnElectronicDeviceHeader(device.id)"
        :businessUnit="businessUnit"
        :company="company"
        :startDateTime="startDateTime"
        :endDateTime="endDateTime"
      />
    </div>
    <div v-else>
      <PrintControlTape
        ref="printControlTape"
        :invoices="invoices"
        :invoiceHeader="invoiceHeader"
        :businessUnit="businessUnit"
        :company="company"
        :startDateTime="startDateTime"
        :endDateTime="endDateTime"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import FileSaver from 'file-saver'
import moment from 'moment'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import PrintControlTape from '@/components/PrintControlTape'

export default {
  components: {
    PrintControlTape
  },
  mixins: [
    asyncDataStatus
  ],
  data () {
    return {
      deviceId: this.$route.query.deviceId !== 'null' ? this.$route.query.deviceId : null,
      startDateTime: this.$route.query.startDateTime,
      endDateTime: this.$route.query.endDateTime,
      shouldSave: this.$route.query.shouldSave === 'true',
      onlyReversed: this.$route.query.onlyReversed === 'true',
      onlyClients: this.$route.query.onlyClients === 'true',
      onlyUser: this.$route.query.onlyUser
    }
  },
  computed: {
    device () {
      return this.$store.state.devices.items[this.deviceId]
    },
    devices () {
      return Object.values(this.$store.state.devices.items)
    },
    businessUnit () {
      return this.$store.state.businessUnits.currentBusinessUnit
    },
    company () {
      return this.$store.state.companies.myCompany
    },
    invoices () {
      return Object.values(this.$store.state.invoices.items)
      .filter(inv => (
          this.onlyClients ? inv.client !== null : true)
        &&
        (this.onlyReversed ? inv.reversed_invoice !== null : true)
        &&
        (this.deviceId && this.deviceId !== null ? this.deviceId == inv.electronic_device : true) // eslint-disable-line
        )
        .map(invoice => {
          return {
            ...invoice,
            taxGroups: this.taxGroups(invoice.articles)
          }
        })
        .sort((a, b) => {
          return moment(a.date).isBefore(b.date) ? -1 : 1
        })
    },
    invoicesDevice () {
      return (id) => Object.values(this.$store.state.invoices.items)
        .filter(inv =>
            inv.electronic_device === id
          &&
            (this.onlyClients ? inv.client !== null : true)
          &&
            (this.onlyReversed ? inv.reversed_invoice !== null : true)
          &&
            (this.onlyUser && this.onlyUser !== null ? this.onlyUser == inv.user_account : true)  // eslint-disable-line
        ) // eslint-disable-line
        .map(invoice => {
          return {
            ...invoice,
            taxGroups: this.taxGroups(invoice.articles)
          }
        })
        .sort((a, b) => {
          return moment(a.date).isBefore(b.date) ? -1 : 1
        })
    },
    invoiceHeader () {
      return this.deviceId ? this.$store.state.devices.invoiceHeader : this.$store.state.businessUnits.currentBusinessUnit.invoice_header
    }
  },
  methods: {
    ...mapActions('devices', { loadDevices: 'loadItems' }),
    ...mapActions('devices', { devicesGetHeader: 'getHeader' }),
    ...mapActions('businessunits', { busUGetHeader: 'getHeader' }),
    ...mapActions('invoices', { findInvoices: 'loadItemsWithClients' }),
    closeWindow () {
      window.close()
    },
    async returnElectronicDeviceHeader (id) {
      const devhead = await this.devicesGetHeader({ electronicDeviceId: id })
      return devhead
    },
    taxGroups (articles) {
      const groups = {}
      articles.forEach(article => {
        const key = article.tax_level_value.toString()
        if (groups[key]) {
          groups[key].taxable_amount += article.taxable_amount
          groups[key].tax_amount += article.tax_amount
          groups[key].price += article.total_amount
        } else {
          groups[key] = {
            tax_level_value: article.tax_level_value,
            taxable_amount: article.taxable_amount,
            tax_amount: article.tax_amount,
            price: article.total_amount
          }
        }
      })
      return Object.values(groups)
    }
  },
  created () {
    this.loadDevices()
      .then(response => {
        const promiseLand = []
        if (!this.deviceId) {
          promiseLand.push(this.findInvoices({
            businessUnitId: this.businessUnit.id,
            dateFrom: moment(this.startDateTime).format('YYYY-MM-DDTHH:mm:ss'),
            dateTo: moment(this.endDateTime).format('YYYY-MM-DDTHH:mm:ss')
          }))
        } else {
          promiseLand.push(this.devicesGetHeader({ electronicDeviceId: this.deviceId }))
          promiseLand.push(this.findInvoices({
            businessUnitId: this.businessUnit.id,
            electronicDeviceId: this.deviceId,
            dateFrom: moment(this.startDateTime).format('YYYY-MM-DDTHH:mm:ss'),
            dateTo: moment(this.endDateTime).format('YYYY-MM-DDTHH:mm:ss')
          }))
        }
        Promise.all(promiseLand)
          .then(response => {
            console.log('Devices: ', this.devices)
            this.asyncDataStatus_fetched()
            if (this.shouldSave !== false) {
              this.$nextTick(() => {
                const page = document.documentElement.innerHTML
                const blob = new Blob([page], { type: 'text/plain;charset=utf-8' })
                const date = moment().format('DD.MM.YYYY HH:mm')
                FileSaver.saveAs(blob, `Kontrolni trak ${this.device.electronic_device_id} ${date}.html`)
                setTimeout(() => {
                  window.close()
                }, 300)
              })
            }
          })
      })
  }
}
</script>

<style lang="scss" scoped>
.printControlTapeWrapper {
  display: flex;
  overflow: auto;
  pre {
    margin: 2rem;
  }
}
</style>